/**
 * Pipe implementation for UI Label Translate.
 * This file provides reusable view-layer transformation logic for templates.
 */
import { ChangeDetectorRef, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { resolveTranslatedUiLabel } from './ui-label-translate.util';

@Pipe({
  name: 'uiLabelTranslate',
  standalone: true,
  pure: false
})
export class UiLabelTranslatePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    // OnPush wrappers do not automatically re-check when ngx-translate changes
    // language, so mirror TranslatePipe's behavior and mark the host view dirty.
    merge(
      this.translate.onLangChange,
      this.translate.onTranslationChange,
      this.translate.onFallbackLangChange
    )
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.cdr.markForCheck());
  }

  transform(value: string | null | undefined): string {
    return resolveTranslatedUiLabel(this.translate, value);
  }
}
